export const normalizeMobilePhone = (mobile) => {
  mobile = mobile + '';
  if (mobile?.length === 13 && mobile?.slice(0, 3) === '+98')
    return `0${mobile.slice(3)}`;
  return mobile;
};
export default normalizeMobilePhone;
